import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';
import { scrollToTop } from '@utils/usefulFuncs';
import QuickLookTool from '@containers/DigitalAnalyst/QuickLookTool';
import { AI_TOOLS } from '@constants';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const tool = AI_TOOLS.QUICK_LOOK_LEGACY;

function QuickLook() {
  const navigate = useNavigate();

  const onGoBack = () => navigate(ROUTES.home);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <QuickLookTool onGoBack={onGoBack} tool={tool} />
      </Body>
    </PageWrapper>
  );
}

export default QuickLook;
